__turbopack_context__.v({
  "cards": "_2NCdJa_cards",
  "content": "_2NCdJa_content",
  "headContact": "_2NCdJa_headContact",
  "imageContainer": "_2NCdJa_imageContainer",
  "p": "_2NCdJa_p",
  "page-body-wrap": "_2NCdJa_page-body-wrap",
  "pagehero": "_2NCdJa_pagehero",
  "paragraph": "_2NCdJa_paragraph",
  "paragraph-content": "_2NCdJa_paragraph-content",
  "phonecontent": "_2NCdJa_phonecontent",
  "sectionCard": "_2NCdJa_sectionCard",
  "store": "_2NCdJa_store",
  "t": "_2NCdJa_t",
  "title": "_2NCdJa_title",
  "wrap-container": "_2NCdJa_wrap-container",
  "wrap-content": "_2NCdJa_wrap-content",
});
